import { createContext } from 'react'

const DataCollectedModalContext = createContext()

export default DataCollectedModalContext
